import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const NumberDraggable = () => {
  const id = v4()
  const type = FormItemType.InputNumber

  return (
    <FormItemDraggableBase
      icon={IconEnum.Number}
      id={id}
      title="formBuilder.numberField"
      type={type}
    />
  )
}
